import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";

import { SeverityDot } from "@/shared/ui/severity-dot";

import { PURCHASE_VERDICT_LABELS } from "../../model/PURCHASE_VERDICT_LABELS";
import { PURCHASE_VERDICT_TONES } from "../../model/PURCHASE_VERDICT_TONES";
import { SLOT_COLORS } from "./SLOT_COLORS";

const LABEL = msg({ id: "analysis.buy.legend", message: "Legend" });
const SLOTS = [
  { slot: "weapon", label: msg({ id: "analysis.buy.slot.weapon", message: "weapon" }) },
  { slot: "vitality", label: msg({ id: "analysis.buy.slot.vitality", message: "vitality" }) },
  { slot: "spirit", label: msg({ id: "analysis.buy.slot.spirit", message: "spirit" }) },
] as const;
const VERDICTS = ["on_time", "late", "very_late"] as const;
const PICK = msg({ id: "analysis.buy.legend.situational", message: "not everyone takes it" });
const SHARE = msg({
  id: "analysis.buy.legend.share",
  message: "under the icon — how often it is taken",
});

// Легенда таймлайна закупа: цвет оценки покупки, что за доля под иконкой и цвет ветки
// магазина. «По ситуации» и «редкий выбор» — один пункт: кружок у них одинаковый, разницу
// видно по доле.
export const PurchaseLegend = () => {
  const { _ } = useLingui();
  return (
    <ul aria-label={_(LABEL)} className="flex flex-wrap gap-x-4 gap-y-2 text-xs text-muted">
      {VERDICTS.map((verdict) => (
        <li key={verdict} className="inline-flex items-center gap-1.5">
          <SeverityDot severity={PURCHASE_VERDICT_TONES[verdict]} className="size-3.5 text-[9px]" />
          {_(PURCHASE_VERDICT_LABELS[verdict])}
        </li>
      ))}
      <li className="inline-flex items-center gap-1.5">
        <SeverityDot severity="neutral" className="size-3.5 text-[9px]" />
        {_(PICK)}
      </li>
      <li>{_(SHARE)}</li>
      {SLOTS.map(({ slot, label }, index) => (
        <li
          key={slot}
          className={
            index === 0
              ? "ml-2 inline-flex items-center gap-1.5"
              : "inline-flex items-center gap-1.5"
          }
        >
          <span aria-hidden="true" className={`h-1 w-3.5 ${SLOT_COLORS[slot].bar}`} />
          {_(label)}
        </li>
      ))}
    </ul>
  );
};
